var _path, _path2, _polygon, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515.95 128.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.41,66.77c0,7.94-3.69,12.08-9.29,12.08-4.81,0-7.94-3.58-7.94-8.95V39.37h-21v35c0,14.31,8.5,23.15,21.25,23.15a22.63,22.63,0,0,0,17-7.38v5.7h20.91V39.37H197.41Z",
    transform: "translate(0 -0.9)",
    fill: "#241f20",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.5,37.69c-6.94,0-12.53,2.24-16.56,6.26V39.37H224v81.09l20.91-5.59V91.27c4,4,9.62,6.26,16.56,6.26,15.54,0,27.29-12.08,27.29-29.86S277,37.69,261.5,37.69Zm-5,42.39c-6.37,0-11.52-5.37-11.52-12.41s5.15-12.53,11.52-12.53c6.94,0,11.41,5.37,11.41,12.53S263.4,80.08,256.46,80.08Z",
    transform: "translate(0 -0.9)",
    fill: "#241f20",
    fillRule: "evenodd"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "292.92 94.95 313.84 94.95 313.84 8.82 292.92 14.42 292.92 94.95",
    fill: "#241f20",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.71,44c-4-4-9.62-6.26-16.55-6.26-15.55,0-27.29,12.08-27.29,30s11.74,29.86,27.29,29.86c6.93,0,12.53-2.24,16.55-6.26v4.58h20.92V39.37H361.71ZM350.19,80.08c-6.93,0-11.41-5.37-11.41-12.41s4.48-12.53,11.41-12.53c6.38,0,11.52,5.37,11.52,12.53S356.57,80.08,350.19,80.08Z",
    transform: "translate(0 -0.9)",
    fill: "#241f20",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M426.14,37.69a22.61,22.61,0,0,0-17,7.38v-5.7H388.22V95.85h20.92V68.45c0-7.94,3.69-12.08,9.28-12.08,4.81,0,7.94,3.58,7.94,8.95V95.85h21v-35C447.39,46.52,438.89,37.69,426.14,37.69Z",
    transform: "translate(0 -0.9)",
    fill: "#241f20",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M495,15.32V44c-4-4-9.62-6.26-16.56-6.26-15.55,0-27.29,12.08-27.29,30s11.74,29.86,27.29,29.86c6.94,0,12.53-2.24,16.56-6.26v4.58H516V9.73ZM483.52,80.08c-6.94,0-11.41-5.37-11.41-12.41s4.47-12.53,11.41-12.53c6.37,0,11.52,5.37,11.52,12.53S489.89,80.08,483.52,80.08Z",
    transform: "translate(0 -0.9)",
    fill: "#241f20",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.14.9A64.14,64.14,0,1,0,128.27,65,64.14,64.14,0,0,0,64.14.9Zm24.1,70.55c0,15.12-9.52,24.48-23.8,24.48C49.79,95.93,40,86.57,40,71.45V49.87l16-4.26V71.45c0,6.6,3.38,10.29,8.44,10.29,4.69,0,7.83-3.69,7.83-10.29V41.26l16-4.27Z",
    transform: "translate(0 -0.9)",
    fill: "#2574db",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostup);
export default __webpack_public_path__ + "static/media/postup.de95c935c32df21055a0af9635b204a9.svg";
export { ForwardRef as ReactComponent };